import { defineStore } from 'pinia';
import EleveInscriptionAjax from '@/services/EleveInscriptionAjax';
import CSQCOutilsCoursEte from '@/outils/CSQCOutilsCoursEte';
import useAppStore from '@/store/appStore';
import { InscriptionCSS } from '@/outils/Enum';

const racineLocalStorage = 'csqc_coursEte';

export default defineStore('inscriptionStore', {
  state: () => ({
    chargement: false,

    listeBlocOrganisme: [],
    listeCssMinimise: [],
    listeCoursLigne: [],
    listeCoursEleve: [],
    listeOrganismeGratuit: [],
    listeMesureAide: [],
    panneauOuvertCssParticipante: -1,
    eleveId: 0,
    afficherPanier: false,
    optionCss: [],
    estGratuit: false,
    estDejaPaye: false,
    factureId: 0,

    peutSinscrire: false,
    erreurInscription: '',
    urlPlateforme: '',
  }),
  getters: {
    obtenirOptionCss: (state) => (cssId) => {
      const optionCss = state.optionCss.find((x) => x.cssId === cssId);

      if (optionCss) {
        return optionCss;
      }
      return null;
    },
  },
  actions: {
    async definirOptionCSS() {
      try {
        this.chargement = true;
        this.optionCss = await EleveInscriptionAjax.obtenirOptionsCSS();
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
    async definirListeCSSMinimise() {
      try {
        this.chargement = true;
        this.listeCssMinimise = await EleveInscriptionAjax.obtenirListeCssMinimise();
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
    async definirSiGratuit(informationPanierVM) {
      try {
        this.chargement = true;
        this.estGratuit = await EleveInscriptionAjax.verifierSiGratuit(informationPanierVM);
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
    async definirSiDejaPaye(informationPanierVM) {
      try {
        this.chargement = true;
        this.estDejaPaye = await EleveInscriptionAjax.verifierSiDejaPaye(informationPanierVM);
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
    async definirBlocOrganisme(anneeScolaire) {
      try {
        this.chargement = true;
        this.listeBlocOrganisme = await EleveInscriptionAjax.obtenirBlocOrganisme(anneeScolaire);
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
    async definirOrganismeGratuit(cssId) {
      try {
        this.chargement = true;
        // Si le CSSId est null ou vide somehow, on assigne -1 (car on ne peut pas connaitre l'organisme sélectionné)
        if (cssId == null || cssId === '') {
          cssId = -1;
        }

        this.listeOrganismeGratuit = await EleveInscriptionAjax.obteniOrganismeGratuit(cssId.toString());
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
    async definirCoursEnLigne({ cssId, scolariseMaison }) {
      try {
        this.chargement = true;
        const organisme = CSQCOutilsCoursEte.ObtenirOrganisme();
        this.listeCoursLigne = await EleveInscriptionAjax.obtenirListeCoursLigne(cssId, organisme, scolariseMaison);
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
    definirPanneauCSSParticipante(valeurPanneauOuvert) {
      try {
        this.panneauOuvertCssParticipante = valeurPanneauOuvert;
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
    async acheterPanierExamen(informationPanierVM) {
      try {
        this.chargement = true;
        this.factureId = await EleveInscriptionAjax.validerInscriptionExamen(informationPanierVM);
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
    async acheterPanierGratuit(informationPanierVM) {
      try {
        this.chargement = true;
        this.factureId = await EleveInscriptionAjax.validerInscriptionCoursGratuit(informationPanierVM);
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
    async definirMesuresAide(cssId) {
      try {
        this.chargement = true;

        this.listeMesureAide = await EleveInscriptionAjax.obtenirMesuresAides(cssId);
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },

    async verifierSiDisponible(radioGroupSelectionne, cssSelectionne, estScolariseMaison, estPanier = false) {
      const fakeCSSIdExterne = -1;
      this.erreurInscription = '';

      this.urlPlateforme = '';

      // Gestion du CssId et scolarisé maison sélectionné
      let cssId = fakeCSSIdExterne;
      let estScolarisationMaison = false;

      if (useAppStore().modele.optionRegionale.inscriptionExamenOuverte && !useAppStore().modele.optionRegionale.inscriptionExamenTermine && estPanier === true) {
        cssId = cssSelectionne;
      }

      if (radioGroupSelectionne === InscriptionCSS.CSSMonteregieEstrie && cssSelectionne != null) {
        cssId = cssSelectionne.cssId;
        estScolarisationMaison = estScolariseMaison;
      }

      localStorage.setItem(`${racineLocalStorage}_selectionInscription`, radioGroupSelectionne);
      localStorage.setItem(`${racineLocalStorage}_CSSId`, cssId);
      localStorage.setItem(`${racineLocalStorage}_scolarisationMaison`, estScolarisationMaison);

      await EleveInscriptionAjax.obtenirListeCoursLigne(cssId, radioGroupSelectionne, estScolarisationMaison).then(async (data) => {
        this.listeCoursLigne = data;
      });

      if (this.listeCoursLigne.length > 0) {
        // Si est de la monteregieEstrie mais n'a pas encore choisi de CSS
        if (radioGroupSelectionne === InscriptionCSS.CSSMonteregieEstrie && cssSelectionne == null) {
          this.peutSinscrire = false;
        } else {
          this.peutSinscrire = true;
        }
        this.erreurInscription = '';
      } else {
        this.peutSinscrire = false;
        this.erreurInscription = CSQCOutilsCoursEte.CreerMessageErreurInscription(this.listeBlocOrganisme);
      }

      if (!estScolarisationMaison) {
        const optionCss = this.obtenirOptionCss(cssId);
        this.urlPlateforme = CSQCOutilsCoursEte.ObtenirURLPlateforme(optionCss);
      }
    },
  },
});
